export default "__VITE_ASSET__CxLKRqB0__"